<at-members-filter #filter (filterChange)="filterValue.set($event)">
  <h3 class="heading-lg">Members RSVP responses</h3>
</at-members-filter>

<div class="members breakout">
  @if (filteredResponses().NotReplied.length > 0) {
    <ng-container
      *ngTemplateOutlet="
        membersList;
        context: {
          $implicit: {
            members: filteredResponses().NotReplied,
            title: 'Not replied',
            isOpen: true
          }
        }
      "></ng-container>
  }

  @if (filteredResponses().No.length > 0) {
    <ng-container
      *ngTemplateOutlet="
        membersList;
        context: {
          $implicit: {
            members: filteredResponses().No,
            title: 'Can\'t go',
            isOpen: true
          }
        }
      "></ng-container>
  }

  @if (filteredResponses().Maybe.length > 0) {
    <ng-container
      *ngTemplateOutlet="
        membersList;
        context: {
          $implicit: {
            members: filteredResponses().Maybe,
            title: 'Not sure yet',
            isOpen: true
          }
        }
      "></ng-container>
  }

  @if (filteredResponses().Yes.length > 0) {
    <ng-container
      *ngTemplateOutlet="
        membersList;
        context: {
          $implicit: {
            members: filteredResponses().Yes,
            title: 'Going!',
            isOpen: true
          }
        }
      "></ng-container>
  }

  @if (isFilterResultEmpty()) {
    <div class="empty-content">
      <p class="body-copy-md">No results found</p>
      <button class="button primary" (click)="filter.clearFilter()">
        Clear filter
      </button>
    </div>
  } @else if (isFilterResultEmpty() && !filterValue()) {
    <div class="empty-content">
      <p class="body-copy-md">No members have submitted their rsvp yet.</p>
    </div>
  }
</div>

<ng-template #membersList let-responses>
  <details class="section-details" [open]="responses.isOpen">
    <summary class="section-summary">
      <div class="section-details-header">
        <h3 class="heading-md">{{ responses.title }}</h3>
        <p class="body-copy-sm">{{ responses.members.length }} members</p>
      </div>
    </summary>
    <ul class="member-list">
      @for (member of responses.members; track member.userId) {
        <li class="member-row">
          <at-display-name showAvatar showEmail [user]="member" [showOwnerBadge]="member.userId | isTripOwner"></at-display-name>
          @if (member.message) {
            <dl class="member-message">
              <dt class="all-caps violet-darker">Message</dt>
              <dd class="body-copy-sm">{{ member.message }}</dd>
            </dl>
          }
        </li>
      }
    </ul>
  </details>
</ng-template>
